/* eslint-disable */
const olx = `<problem>
  <multiplechoiceresponse>
    <choicegroup>
      <choice correct="true"></choice>
      <choice correct="false"></choice>
      <choice correct="false"></choice>
    </choicegroup>
  </multiplechoiceresponse>
</problem>`

const markdown = `( ) an incorrect answer
(x) the correct answer
( ) an incorrect answer
`

export default { olx, markdown };